import RichText from '#components/common/richText/RichText';
import PageTitle from '#components/common/page-title/PageTitle';
import MediaBackground from '#components/common/mediaBackground/MediaBackground';
import PageSection from '#components/sections/page-section/PageSection';
import {
  RemoteContentDocumentBlock,
  TextDocumentBlock,
  Theme,
} from '#types/generated/graphql-types';

type Props = {
  block: TextDocumentBlock | RemoteContentDocumentBlock;
  isTopBlock?: boolean;
  theme?: Theme;
};

const TextDocumentBlock = ({ block, isTopBlock, theme }: Props) => {
  const hasText = block.text?.replace(/<[^>]*>?/gm, '').trim().length > 1;
  return (
    <PageSection bottomGutter={hasText}>
      <header>
        {isTopBlock && theme && (
          <MediaBackground alt={theme.title} src={theme.contentUrl} />
        )}
        <PageTitle title={block.title} element={isTopBlock ? 'h1' : 'h2'} />
        {hasText && <RichText text={block.text} />}
      </header>
    </PageSection>
  );
};

export default TextDocumentBlock;
